export const fieldLabelAttCadastral = {
  cpf: {
    label: 'CPF',
    tipo: 'Pessoais',
  },
  sexo: {
    label: 'Gênero',
    tipo: 'Pessoais',
  },
  nacionalidade: {
    label: 'Nacionalidade',
    tipo: 'Pessoais',
  },
  email: {
    label: 'E-mail',
    tipo: 'Contato',
  },
  rg: {
    label: 'RG',
    tipo: 'Pessoais',
  },
  estadoCivil: {
    label: 'Estado Civil',
    tipo: 'Pessoais',
  },
  pai: {
    label: 'Pai',
    tipo: 'Pessoais',
  },
  mae: {
    label: 'Mãe',
    tipo: 'Pessoais',
  },
  telefoneFixo: {
    label: 'Telefone fixo',
    tipo: 'Contato',
  },
  celular: {
    label: 'Celular',
    tipo: 'Contato',
  },
  endereco: {
    label: 'Endereço',
    tipo: 'Residências',
  },
  numero: {
    label: 'Número',
    tipo: 'Residências',
  },
  complemento: {
    label: 'Complemento',
    tipo: 'Residências',
  },
  bairro: {
    label: 'Bairro',
    tipo: 'Residências',
  },
  cidade: {
    label: 'Cidade',
    tipo: 'Residências',
  },
  estado: {
    label: 'Estado',
    tipo: 'Residências',
  },
  uf: {
    label: 'UF',
    tipo: 'Residências',
  },
  cep: {
    label: 'CEP',
    tipo: 'Residências',
  },
  banco: {
    label: 'Banco',
    tipo: 'Contato',
  },
  conta: {
    label: 'Conta',
    tipo: 'Contato',
  },
  agencia: {
    label: 'Agência',
    tipo: 'Contato',
  },
  digito: {
    label: 'Dígito',
    tipo: 'Contato',
  },
};
